module.exports = __webpack_public_path__ + "img/google.34708547.png";